import PropTypes from 'prop-types';
import { Autocomplete, Box, Button, Grid, TextField } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

const KpiFilters = ({ filtros = [], values, onChange, onApply, loading }) => {
    if (!filtros.length) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                <Button
                    variant="contained"
                    startIcon={<RefreshIcon fontSize="small" />}
                    onClick={onApply}
                    disabled={loading}
                    sx={{ bgcolor: '#6E368C', '&:hover': { bgcolor: '#5a2c73' } }}
                >
                    Atualizar
                </Button>
            </Box>
        );
    }

    const setValue = (chave, value) => {
        onChange({ ...values, [chave]: value });
    };

    return (
        <Box
            sx={{
                mb: 3,
                p: 2.5,
                borderRadius: 3,
                bgcolor: '#fff',
                border: '1px solid #EDE4F5',
                boxShadow: '0 8px 24px rgba(110, 54, 140, 0.06)'
            }}
        >
            <Grid container spacing={2} alignItems="center">
                {filtros.map((filtro) => {
                    const tipo = (filtro.tipo || '').toLowerCase();
                    if (tipo === 'date') {
                        return (
                            <Grid item xs={12} sm={6} md={3} key={filtro.id}>
                                <TextField
                                    fullWidth
                                    type="date"
                                    size="small"
                                    label={filtro.label}
                                    InputLabelProps={{ shrink: true }}
                                    value={values[filtro.chave] || ''}
                                    onChange={(event) => setValue(filtro.chave, event.target.value || null)}
                                />
                            </Grid>
                        );
                    }

                    if (tipo === 'daterange') {
                        const range = values[filtro.chave] || {};
                        return (
                            <Grid item xs={12} md={6} key={filtro.id}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            type="date"
                                            size="small"
                                            label={`${filtro.label} início`}
                                            InputLabelProps={{ shrink: true }}
                                            value={range.inicio || ''}
                                            onChange={(event) =>
                                                setValue(filtro.chave, { ...range, inicio: event.target.value || null })
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            type="date"
                                            size="small"
                                            label={`${filtro.label} fim`}
                                            InputLabelProps={{ shrink: true }}
                                            value={range.fim || ''}
                                            onChange={(event) =>
                                                setValue(filtro.chave, { ...range, fim: event.target.value || null })
                                            }
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        );
                    }

                    const options = filtro.opcoes || [];
                    const multiple = tipo === 'multiselect';
                    const selected = multiple
                        ? options.filter((option) => (values[filtro.chave] || []).map(String).includes(String(option.value)))
                        : options.find((option) => String(option.value) === String(values[filtro.chave] ?? '')) || null;

                    return (
                        <Grid item xs={12} sm={6} md={4} key={filtro.id}>
                            <Autocomplete
                                multiple={multiple}
                                options={options}
                                value={selected}
                                getOptionLabel={(option) => option?.label || ''}
                                isOptionEqualToValue={(option, value) => String(option.value) === String(value.value)}
                                onChange={(_, next) => {
                                    if (multiple) {
                                        setValue(
                                            filtro.chave,
                                            (next || []).map((item) => item.value)
                                        );
                                        return;
                                    }
                                    setValue(filtro.chave, next ? next.value : null);
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} size="small" label={filtro.label} placeholder="Todos" />
                                )}
                            />
                        </Grid>
                    );
                })}
                <Grid item xs={12} md="auto" sx={{ ml: { md: 'auto' } }}>
                    <Button
                        fullWidth
                        variant="contained"
                        startIcon={<RefreshIcon fontSize="small" />}
                        onClick={onApply}
                        disabled={loading}
                        sx={{ bgcolor: '#6E368C', '&:hover': { bgcolor: '#5a2c73' }, minWidth: 140 }}
                    >
                        Aplicar
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

KpiFilters.propTypes = {
    filtros: PropTypes.array,
    values: PropTypes.object,
    onChange: PropTypes.func,
    onApply: PropTypes.func,
    loading: PropTypes.bool
};

export default KpiFilters;
